// This component sets dual crop windows when the windows are toggled on
// This was react-easy-crop (link: https://github.com/ricardo-ch/react-easy-crop)

//Imports
import React, { createRef } from 'react';  //react library
import Button from '@material-ui/core/Button'; //material UI button
import IconButton from '@material-ui/core/IconButton'; //Icon button (close button)
import { Crop } from './utils/Cropping3'; // gets individual cropper class component
import StereoDialog from './StereoDialog' // gets stereographic dialog box
import CloseIcon from '@material-ui/icons/Close'; //gets icon for close button

// class component that sets up a double cropping window with functionality for animating
export class CropWindow extends React.Component {
    constructor(props) {
        super(props);
        // set initial state
        this.state = {
            image: this.props.image,
        }
        // created react refs to get data from child components
        this.leftchild = React.createRef();
        this.rightchild = React.createRef();
    }

    // function to save cropped images
    cropSave = async () => {
            try {
               await this.leftchild.current.returnCroppedImage();
               await this.rightchild.current.returnCroppedImage();
             } catch (e) {
               console.error(e)
             }
           }

    //close for Dialog
    onClose = () => {
        this.setState({ stereoOne: null,
                        stereoTwo: null,})
    }

     //Callback function for returning saved images as state values 
    callback = (position, value) => {
        if (position === 'left'){
            this.setState({stereoOne: value})
        }
        else {
            this.setState({stereoTwo: value})
        }
    } 
    render() {
        return <div>
                    <div className = "cropContainer" >
                        {/*  This sets up cropping windows */}
                        {/* ref is for calling child functions from parent component (always use this sparingly) */}

                        <Crop Img={this.state.image} position = 'left' sliderPos='left_slide' buttonLoc='leftShowButton' ref ={this.leftchild} callback ={this.callback}/>
                        <Crop Img={this.props.image} position ='right' sliderPos='right_slide' buttonLoc='rightShowButton' ref ={this.rightchild} callback ={this.callback}/>

                        {/* This Sets up the top UI inclusing new upload button and close button */}
                        <div className="top-UI">
                            <input id="cropButton" type="button" className='hidden'/>
                            <label htmlFor="cropButton">
                                <Button variant="outlined"  component="span" id ='cropButton'  onClick={this.cropSave}>
                                Stereo-Animate!
                                </Button>
                            </label> 
                            <input type='button' id="close-button" className='hidden' />
                            <label htmlFor="close-button">
                                <IconButton id = 'close-button' onClick={this.props.exit} >
                                    <CloseIcon />
                                </IconButton>
                            </label>
                        </div>
                        {/* This Sets up the stereograph dialog */}
                        <StereoDialog img ={this.state.stereoOne} img2 = {this.state.stereoTwo} onClose= {this.onClose} />
                    </div>
               </div>
    }
}